export const ENV = {
    PUBLIC_ENV: process.env.REACT_APP_PUBLIC_ENVIROMENT as string,
    URL_PAYMENT: process.env.REACT_APP_URL_PAYMENT as string,
    GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID as string,
};
